import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { RovoButtonProps } from './RovoButton';

const Null = () => null;

export const LazyRovoButton: FunctionComponent<RovoButtonProps> = (props) => {
  const RovoButton = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "rovo-button", webpackPrefetch: true */ './RovoButton'
      ),
    { namedImport: 'RovoButton' },
  );
  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'requestAccessV3',
      }}
      errorHandlerComponent={Null}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <RovoButton {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
